import { render, staticRenderFns } from "./PermissionTree.vue?vue&type=template&id=53ecf119&scoped=true"
import script from "./PermissionTree.vue?vue&type=script&lang=js"
export * from "./PermissionTree.vue?vue&type=script&lang=js"
import style0 from "./PermissionTree.vue?vue&type=style&index=0&id=53ecf119&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ecf119",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53ecf119')) {
      api.createRecord('53ecf119', component.options)
    } else {
      api.reload('53ecf119', component.options)
    }
    module.hot.accept("./PermissionTree.vue?vue&type=template&id=53ecf119&scoped=true", function () {
      api.rerender('53ecf119', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/PermissionTree.vue"
export default component.exports